import React from 'react';
import {
  InputGroup,
  Button,
  Input,
  InputGroupButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

class MasquaradeDropdown extends React.Component {
  render() {
    const toggleSplit = true;
    const {
      masquaradeUsers,
      masquaradeUserCount,
      onSearchChange,
      onSelectUser,
      isMasquaraded,
      onRevertMasquarade,
      displayUserRole,
      currentUserRole,
    } = this.props;
    //
    if (isMasquaraded) {
      return (
        <span>
          <InputGroup>
            <Button onClick={() => onRevertMasquarade()}>Revert Masquarade</Button>
          </InputGroup>
        </span>
      );
    }
    if (displayUserRole !== currentUserRole) {
      return null;
    }
    return (
      <span>
        <InputGroup>
          <InputGroupButtonDropdown addonType="prepend" isOpen={masquaradeUserCount > 0} toggle={() => toggleSplit}>
            <DropdownToggle split outline />
            <DropdownMenu>
              {masquaradeUsers ? (
                masquaradeUsers.map((user) => (
                  <DropdownItem key={user.id} id={user.id} onClick={() => onSelectUser(user.id)}>
                    <b>{user.login}</b> <i>{user.email}</i> [{user.role}:{user.ocupation}] - {user.organization}{' '}
                  </DropdownItem>
                ))
              ) : (
                <DropdownItem header>Select Users</DropdownItem>
              )}
              {masquaradeUserCount > 20 ? (
                <DropdownItem header>... {masquaradeUserCount} users total</DropdownItem>
              ) : null}
            </DropdownMenu>
          </InputGroupButtonDropdown>
          <Input placeholder="Find User by Name, Role, Org" onChange={(event) => onSearchChange(event.target.value)} />
        </InputGroup>
      </span>
    );
  }
}

export default MasquaradeDropdown;
